// VIS-267: the phone set holds its sun's still shadow maps while the camera's view moves (the owner's pick, 2026-10-26:
// "Option A for shadows. I agree to size change"). A pinch redrew them 10-14 times (+40-90 draw calls each: a CPU spike
// on a phone every time); held, the kept map and its matrix stay in use while the view moves (a pinch, a drag, the
// release glide, a flight), as long as the wanted box stays within HOLD of the kept one; their soft edge keeps the width
// the view wants (shadows.js heldEdge). Once the view rests they are redrawn HOLD_SETTLE pictures after the stop, one
// cascade a picture, so a still picture is the same as without the hold. "Moving" = the view or projection changed since
// the last picture (as render.js HalfAONode.moved()), never the finger. Phone set only (main.js SHADOW_HOLD: never
// computers, lobby screens or the rescue set). Engine-generic: no resort data.

/** () => true when the camera's view (rotation 1e-5, translation 1 mm: a damped camera at rest still moves by
 *  rounding) or projection changed since the last view it stored; it stores the view when it changed. The first call
 *  says moved. */
export function viewWatch(camera) {
  const s = new Float64Array(32);
  let first = true;
  return function moved() {
    const v = camera.matrixWorldInverse.elements, p = camera.projectionMatrix.elements;
    let m = first;
    for (let i = 0; i < 16 && !m; i++) m = Math.abs(v[i] - s[i]) > (i >= 12 && i < 15 ? 1e-3 : 1e-5) || Math.abs(p[i] - s[16 + i]) > 1e-6;
    if (m) { s.set(v); s.set(p, 16); first = false; }
    return m;
  };
}

// How far a held still map may fall behind the box the view wants. grow: its half-size at most x2 or /2 of the kept
// one; shift: its centre at most this share of the kept half-size off (the middle 60 % of the kept box). Past either
// the map is redrawn as before, while moving too.
export const HOLD = { grow: 2, shift: 0.6 };
// Still pictures before a held map is redrawn: ~0.1 s at the phone clock's 30 a second, while the eye still follows the
// stop (6, ~0.2 s, the keeper's `settle` for what is not held: the picture stood, then the shadows changed).
export const HOLD_SETTLE = 3;
/** kept / now: [halfX, halfY] of the kept and the wanted box (light space), shift: [dx, dy] of the wanted centre from
 *  the kept one. true = the kept map still serves the view. */
export function holdBox(kept, now, shift, H = HOLD) {
  for (let i = 0; i < 2; i++) {
    const r = now[i] / kept[i];
    if (!(r <= H.grow && r >= 1 / H.grow)) return false;
    if (!(Math.abs(shift[i]) <= H.shift * kept[i])) return false;
  }
  return true;
}
